import { Vue, Options } from 'vue-class-component';
import Toast from 'primevue/toast';

import TheHeader from '../TheHeader/TheHeader.vue';
import TheSidebar from '../TheSidebar/TheSidebar.vue';

@Options({
  name: 'MainContainer',
  components: {
    TheHeader,
    TheSidebar,
    Toast,
  },
})
export default class MainContainer extends Vue {
  get routeName() {
    return this.$route.name;
  }

  get showSidebar() {
    const currentRoute: string = this.routeName?.toString() ?? '';
    return !currentRoute?.includes('plants');
  }
}
